module.exports = __webpack_public_path__ + "static/media/hyria-logo.ef8ebb95.jpg";